/**
 * Filtr formatujący adres obiektu
 *
 * @export
 * @param {*} item
 * @returns
 */
export function address(item: any) {
  return !item.city || !item.street
    ? 'Brak'
    : `${item.street} ${item.homeNumber}${item.localNumber ? '/' + item.localNumber : ''}, ${
        item.postalCode ? item.postalCode : ''
      } ${item.city}`;
}
